import { Button, H2, H3 } from '@selina-finance/ui';

import Logos from '@src/ui/components/Icons/Logos';

import Help from '../Help/Help';

const ErrorView = ({ onRetry }: { onRetry: () => void }) => {
    return (
        <div className='md:pb-10 pt-12 sm:pt-20 lg:pt-32 max-w-2xl mx-auto'>
            <div className='sm:flex sm:justify-between md:flex md:justify-between lg:flex lg:justify-between xl:flex xl:justify-between'>
                <div className='flex justify-center'>
                    <Logos />
                </div>
                <div className='flex justify-center text-center sm:text-left'>
                    <div className='text-lg pl-0 md:pl-16 lg:pl-16'>
                        <p className='tracking-widest text-periwinkle-500 font-bold text-sm_body mt-10 sm:mt-0 lg:mt-0'>
                            500 ERROR
                        </p>
                        <H2 className='font-bold pb-2 hidden lg:flex'>
                            Sorry, something’s gone wrong
                        </H2>
                        <H3 className='mb-3 block lg:hidden mt-2 sm:mt-0'>
                            Sorry, something’s gone wrong
                        </H3>
                        <p className='text-xl leading-6'>
                            Something has gone wrong on our end, please try to
                            reload the page.
                        </p>
                        <div className='flex justify-center sm:justify-start'>
                            <Button
                                color='tertiary'
                                size='medium'
                                className='font-bold my-9 w-full lg:w-auto'
                                onClick={onRetry}
                            >
                                Try again
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <Help />
        </div>
    );
};

export default ErrorView;
